import { type SVGProps } from "react";

import { type IconName } from "./name";
import spriteHref from "./sprite.svg";

interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name" | "ref"> {
  name: IconName;
  size?: number;
  /** Overrides the stroke-width baked into Tabler symbols. Applied via CSS so it cascades through `<use>`. Default `1`. */
  strokeWidth?: number;
}

const DEFAULT_STROKE_WIDTH = 1;

export function Icon(props: IconProps) {
  const {
    name,
    size = 24,
    strokeWidth = DEFAULT_STROKE_WIDTH,
    style,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    role,
    focusable,
    width,
    height,
    ...rest
  } = props;
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      style={{ strokeWidth, ...style }}
      focusable={focusable ?? "false"}
      role={role ?? (ariaLabel ? "img" : undefined)}
      aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
      aria-label={ariaLabel}
    >
      <use href={`${spriteHref}#${name}`} />
    </svg>
  );
}
